import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import { getProjectDownloadCount } from '@pt/api/gmaker/project.js';
import _ from 'lodash';

export default {
  props: {
    type: {
      type: String, // download push
      default: 'download'
    },
    channels: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    counterVisible: {
      type: Boolean,
      default: true
    },

    projectId: {
      type: [Number, Array, String],
      require: true
    },

    selectedChannelIds: {
      type: String,
      default: ''
    },

    quality: {
      type: String,
      default: '0,0,0'
    },

    overDownloadLimit: [Boolean],

    projectCountRequest: [Function, String]
  },

  name: 'packageManager.vue',

  components: {},

  data: function data() {
    return {
      error: '',
      groups: 1,
      downloads: 0,
      left_downloads: 0,
      total_downloads: 0,
      countLoading: false,
      downloadMap: {}
    };
  },
  mounted: function mounted() {
    if (!this.isChannelPacking) {
      this.getDownloadCount();
    }
  },


  methods: {
    getDownloadCount: function getDownloadCount() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res, data, postdata;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.countLoading = true;
                res = void 0, data = void 0;
                postdata = {
                  project_id: Array.isArray(_this.projectId) ? _this.projectId.toString() : _this.projectId,
                  channel_ids: _this.selectedChannelIds,
                  quality: _this.quality,
                  type: _this.type
                };

                if (!_this.projectCountRequest) {
                  _context.next = 10;
                  break;
                }

                _context.next = 6;
                return _this.projectCountRequest(postdata);

              case 6:
                res = _context.sent;

                data = _.get(res, 'data') || {};
                _context.next = 14;
                break;

              case 10:
                _context.next = 12;
                return getProjectDownloadCount(postdata);

              case 12:
                res = _context.sent;

                data = _.get(res, 'data.data') || {};

              case 14:
                _this.countLoading = false;
                _this.groups = data.groups || 1;
                _this.left_downloads = data.left_downloads || 0;
                _this.total_downloads = data.total_downloads || 0;
                _this.downloadMap = data.downloads || {};
                _this.$emit('totalDownload', _this.total_downloads);
                _this.setDownloadsCount(_this.selectedChannelIds);

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getErrorMessage: function getErrorMessage() {
      this.error = '' + this.$t('playTurbo.common.pushDialog.packageManager.overTips');
    },
    setDownloadsCount: function setDownloadsCount(val) {
      var _this2 = this;

      var ids = val.split(',');
      var count = 0;
      ids.forEach(function (val) {
        if (_this2.downloadMap[val]) {
          count = count + _this2.downloadMap[val];
        }
      });
      this.downloads = count;
      this.updateOverLimit();
    },
    updateOverLimit: function updateOverLimit() {
      if (this.downloads > this.left_downloads && this.total_downloads !== -1) {
        this.getErrorMessage();
        this.$emit('update:overDownloadLimit', true);
      } else {
        this.$emit('update:overDownloadLimit', false);
        this.error = '';
      }
    }
  },
  computed: {
    isChannelPacking: function isChannelPacking() {
      return this.channels.some(function (item) {
        return item.loading === true;
      });
    }
  },
  watch: {
    selectedChannelIds: function selectedChannelIds(val) {
      // 选中渠道发生变化，且无打包行为触发
      if (!this.isChannelPacking) {
        this.getDownloadCount();
      }
    },
    isChannelPacking: function isChannelPacking(val) {
      // 渠道打包行为变更，触发重新计算
      if (!val) {
        this.getDownloadCount();
      }
    }
  }
};